<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7qFl47/tc-custom/9780062026361.jpg?1731838250083" alt="This image is the cover for the book One Dharma"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One Dharma
      </h1>
      <p class="bookDescription body article font2">
        <b>One of America’s foremost Buddhist teachers shares a “wise and mature vision of Buddhism [that is] destined to be a classic”—preface by the Dalai Lama (Jack Kornfield).</b><br/><br/>Buddhism has evolved in various ways across time and geography. Now, as a genuine Western Buddhism takes root on American soil, Buddhist teacher Joseph Goldstein explores its unique traditions as well as its essential adherence to the universal principles of mindfulness, loving-kindness, and nonattachment. <br/><br/>In <i>One Dharma</i>, Goldstein distills a lifetime of practice and teaching, including his years at the renowned Insight Meditation Society, to present a groundbreaking, contemporary vision of Buddhism.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Goldstein
      </h2>
      
      <p class="authorDescription body article"><P>Joseph Goldstein is a cofounder of the Insight Meditation Society in Barre, Massachusetts, where he is one of the resident guiding teachers. He is the author of <I>The Experience of Insight</I> and <I>Insight Meditation</I> and has coauthored books with both Sharon Salzberg and Jack Kornfield. He has studied and practiced meditation since 1967 under the guidance of eminent teachers from India, Burma, and Tibet. He lectures and leads retreats around the world.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42b6e62d